/**
 * @generated SignedSource<<591f0d20995f4683d8e672d752d1fbe6>>
 * @relayHash 1c0d44ce3b2c58317bf90bc959b33659
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 949164561569f4623565ddcd1b7ec7ef252dc4f441d70fced212ee83718ddbf1

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type ManualTrialConditionQuery$variables = {
  entitlementId: string;
};
export type ManualTrialConditionQuery$data = {
  readonly growthUnifiedProfile_getEntitlementProfile: {
    readonly lastKnownTrial: {
      readonly trialEndTimeStamp: number | null | undefined;
      readonly trialType: GrowthUnifiedProfileTrialType | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ManualTrialConditionQuery = {
  response: ManualTrialConditionQuery$data;
  variables: ManualTrialConditionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entitlementId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "entitlementId",
        "variableName": "entitlementId"
      }
    ],
    "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
    "kind": "LinkedField",
    "name": "growthUnifiedProfile_getEntitlementProfile",
    "plural": false,
    "selections": [
      {
        "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
        "kind": "LinkedField",
        "name": "lastKnownTrial",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "trialEndTimeStamp"
          },
          {
            "kind": "ScalarField",
            "name": "trialType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ManualTrialConditionQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ManualTrialConditionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "949164561569f4623565ddcd1b7ec7ef252dc4f441d70fced212ee83718ddbf1",
    "metadata": {},
    "name": "ManualTrialConditionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "68b9375096cd3e696509be3455612a07";

export default node;
